/** Formatação PT para a UI. */

export function n(v: unknown): number | null {
  if (v === null || v === undefined || v === "") return null
  const x = Number(v)
  return Number.isFinite(x) ? x : null
}

export const eur = (v: unknown) => {
  const x = n(v)
  return x === null ? "—" : `${x.toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
}

export const kg = (v: unknown) => {
  const x = n(v)
  return x === null ? "—" : `${x.toLocaleString("pt-PT", { maximumFractionDigits: x < 10 ? 1 : 0 })} kg`
}

export const m3 = (v: unknown) => {
  const x = n(v)
  return x === null ? "—" : `${x.toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m³`
}

const LISBON_DAY = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Lisbon", year: "numeric", month: "2-digit", day: "2-digit" })

/**
 * Qualquer data que a API devolva → "AAAA-MM-DD". As colunas DATE chegam
 * como instante UTC do fuso do servidor (`2026-10-13T23:00:00.000Z` pode ser
 * o dia 14 em Lisboa): lê-se o instante no fuso de Lisboa em vez de cortar o
 * texto. Texto "AAAA-MM-DD" passa tal e qual.
 */
export const day10 = (d: string | null | undefined) => {
  if (!d) return null
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d
  if (/^\d{4}-\d{2}-\d{2}T/.test(d)) {
    const dt = new Date(d)
    return Number.isNaN(dt.getTime()) ? d.slice(0, 10) : LISBON_DAY.format(dt)
  }
  return d.slice(0, 10)
}

/** "2026-10-09" → "09/10". */
export const dm = (d: string | null | undefined) => {
  const x = day10(d)
  return x ? `${x.slice(8, 10)}/${x.slice(5, 7)}` : "—"
}

const WEEKDAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
/** "2026-10-09" → "Sex 9". */
export const dayShort = (d: string | null | undefined) => {
  const x = day10(d)
  if (!x) return "—"
  const dt = new Date(`${x}T12:00:00Z`)
  return `${WEEKDAYS[dt.getUTCDay()]} ${dt.getUTCDate()}`
}

/** Hoje em Lisboa (AAAA-MM-DD). */
export function todayLisbon(): string {
  return LISBON_DAY.format(new Date())
}

/** Minutos desde a meia-noite → "HH:MM". */
export const hhmm = (min: number | null | undefined) =>
  min === null || min === undefined ? "—" : `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(Math.round(min % 60)).padStart(2, "0")}`
